<template>
    <div class="space-y-4">
        <h3 class="text-2xl/[1.2]">
            {{ header.title }}
        </h3>
        <p v-if="header.subtitle">
            {{ header.subtitle }}
        </p>

        <comments-list-form
            v-if="singleCommentStatus === 'open'"
            :data="{ singleId }"
        />

        <ul
            v-if="!hideComments"
            class="*:mt-6 *:bg-white *:shadow-sm"
        >
            <li>
                <div class="bg-gray-100 p-6 text-gray-700 [&_a]:text-inherit">
                    <div class="mb-4 flex justify-between">
                        <a
                            href="https://zalog.ro/"
                            target="_blank"
                            rel="external noopener"
                        >Catalin Zălog</a>
                        <div class="text-[.875em]">
                            publicitate
                        </div>
                    </div>
                    <div class="wrap-break-word">
                        <p>
                            Colaborez cu cabral de prin 2014. Îmi place pentru că apreciază <a
                                href="https://zalog.ro/"
                                title="web development"
                                target="_blank"
                                rel="external noopener"
                            >serviciile mele</a>.
                        </p>
                    </div>
                </div>
            </li>
            <li
                v-for="(comment, index) in comments && comments.nodes"
                :id="`comment-${comment.databaseId}`"
                :key="'comments-comment-' + comment.databaseId"
            >
                <comments-list-comment
                    v-observe-visibility="{
                        callback: isVisible => emitVisibleLastComment(isVisible, index + 1),
                        once: true,
                    }"
                    :comment="comment"
                />

                <ul
                    v-if="comment.replies && comment.replies.nodes.length"
                    class="border-t border-gray-300"
                >
                    <li
                        v-for="commentReply in comment.replies.nodes"
                        :id="`comment-${commentReply.databaseId}`"
                        :key="'comments-comment-l1-' + commentReply.databaseId"
                    >
                        <comments-list-comment
                            :comment="commentReply"
                        />
                    </li>
                </ul>

                <comments-list-form
                    v-if="singleCommentStatus === 'open'"
                    :data="{
                        label: 'răspunde-i',
                        singleId,
                        commentId: comment.databaseId,
                        index,
                    }"
                />
            </li>
            <li class="hidden py-4 text-center in-[.loading]:block">
                <base-spinner />
            </li>
        </ul>
    </div>
</template>

<script>
import BaseSpinner from './BaseSpinner.vue';
import CommentsListComment from './CommentsListComment.vue';
import CommentsListForm from './CommentsListForm.vue';

export default {
    components: {
        BaseSpinner,
        CommentsListComment,
        CommentsListForm,
    },

    props: {
        comments: {
            type: Object,
            default: () => ({}),
        },
        singleId: {
            type: Number,
            default: null,
        },
        singleCommentStatus: {
            type: String, // 'open' || 'closed'
            default: null,
        },
        hideComments: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['is-visible-last'],

    created() {
        this.getHeader();
    },

    methods: {
        emitVisibleLastComment(isVisible, index) {
            if (!isVisible || this.comments.nodes.length !== index) return;

            this.$emit('is-visible-last');
        },
        getHeader() {
            const output = { title: 'Comentarii' };

            if (this.singleCommentStatus === 'closed') output.title = 'Comentariile au fost închise';
            else if (this.hideComments) {
                Object.assign(output, {
                    title: 'Comentariile sunt ascunse momentan',
                    subtitle: 'Dar tu poți adăuga oricând comentariul tău pentru concurs.',
                });
            }

            this.header = output;
        },
    },
};
</script>
